// Components
import verifyNumber from '@/components/trade-in/VerifyNumber.vue';
import verifyCode from '@/components/trade-in/VerifyCode.vue';

// Views
import SelectionYear from '@/views/trade-in/SelectionYear.vue';
import SelectionMake from '@/views/trade-in/SelectionMake.vue';
import SelectionModel from '@/views/trade-in/SelectionModel.vue';
import SelectionStyle from '@/views/trade-in/SelectionStyle.vue';
import SelectionTrim from '@/views/trade-in/SelectionTrim.vue';
import PersonalInfoForm from '@/views/trade-in/PersonalInfoForm.vue';
import MobileReport from '@/views/trade-in/MobileReport.vue';
import ErrorPage from '@/views/shared/ErrorPageV2.vue';
import SelectTradeVehicleType from '@/views/trade-in/SelectTradeVehicleType.vue';
import VehicleDetails from '@/views/trade-in/VehicleDetails.vue';
import PersonalInfoFormV2 from '@/views/trade-in/PersonalInfoFormV2.vue';
import RedirectRoute from '@/components/RedirectEntryRoute.vue';
import AdditionalVehicleDetails from '@/views/shared/AdditionalVehicleDetails.vue';
import CarfaxBasicForm from '@/components/shared/trade-in-carfax/CarfaxBasicForm.vue';
import CarfaxDetailsForm from '@/components/shared/trade-in-carfax/CarfaxDetailsForm.vue';

export default [
  {
    path: '',
    component: RedirectRoute,
    meta: {
      skipImpression: true,
    },
  },
  {
    path: 'select-trade-vehicle-type',
    name: 'select-trade-vehicle-type-mobile',
    component: SelectTradeVehicleType,
    meta: {
      progressBar: {
        currentStep: 0,
      },
      headerIcon: 'back',
    },
  },
  {
    path: 'trade-vehicle-details',
    name: 'trade-vehicle-details-mobile',
    component: VehicleDetails,
    meta: {
      progressBar: {
        currentStep: 1,
      },
      headerIcon: 'back',
      hideSelectText: true,
    },
  },
  {
    path: 'personal-info',
    name: 'personal-info-mobile',
    component: PersonalInfoFormV2,
    meta: {
      progressBar: {
        currentStep: 2,
      },
      headerIcon: 'back',
      hideSelectText: true,
    },
  },
  {
    path: 'carfax-basic-form',
    name: 'carfax-basic-form-mobile',
    component: CarfaxBasicForm,
    meta: {
      progressBar: {
        currentStep: 0,
      },
      headerIcon: 'back',
    },
  },
  {
    path: ':year/:make/:model/carfax-details-form',
    name: 'carfax-details-form-mobile',
    component: CarfaxDetailsForm,
    meta: {
      progressBar: {
        currentStep: 1,
      },
      headerIcon: 'back',
    },
    props: true,
  },
  {
    path: 'year',
    name: 'trade-year-mobile',
    component: SelectionYear,
    meta: {
      progressBar: {
        currentStep: 1,
      },
      displayVehicleString: true,
      headerIcon: 'back',
    },
  },
  {
    path: ':year/make',
    name: 'trade-make-mobile',
    component: SelectionMake,
    meta: {
      progressBar: {
        currentStep: 2,
      },
      headerIcon: 'back',
      displayVehicleString: true,
    },
  },
  {
    path: ':year/:make/model',
    name: 'trade-model-mobile',
    component: SelectionModel,
    meta: {
      progressBar: {
        currentStep: 3,
      },
      headerIcon: 'back',
      displayVehicleString: true,
    },
  },
  {
    path: ':year/:make/:model/trim',
    name: 'trade-trim-mobile',
    component: SelectionTrim,
    meta: {
      progressBar: {
        currentStep: 4,
      },
      headerIcon: 'back',
      displayVehicleString: true,
    },
  },
  {
    path: ':year/:make/:model/:trim/style', // Trim is optional
    name: 'trade-style-mobile',
    component: SelectionStyle,
    meta: {
      progressBar: {
        currentStep: 5,
      },
      headerIcon: 'back',
      displayVehicleString: true,
    },
    props: true,
  },
  {
    path: ':year/:make/:model/:trim/:style?/personal-info-form',
    name: 'personal-info-form-mobile',
    component: PersonalInfoForm,
    meta: {
      progressBar: {
        currentStepName: 'personal-info-form',
      },
      headerIcon: 'back',
      displayVehicleString: true,
      hideSelectText: true,
    },
  },
  {
    path: 'additional-vehicle-details',
    name: 'additional-vehicle-details-mobile',
    component: AdditionalVehicleDetails,
    meta: {
      progressBar: {
        currentStepName: 'additional-vehicle-details',
      },
      headerIcon: 'back',
    },
  },
  {
    path: 'mobile-verification',
    name: 'tradein-mobile-verification-mobile',
    component: verifyNumber,
    meta: {
      progressBar: {
        currentStepName: 'mobile-verification',
      },
      headerIcon: 'back',
    },
  },
  {
    path: 'verification-code',
    name: 'tradein-mobile-code-mobile',
    component: verifyCode,
    meta: {
      progressBar: {
        currentStepName: 'verification-code',
      },
      headerIcon: 'back',
    },
  },
  {
    path: 'report',
    name: 'report-mobile',
    component: MobileReport,
    meta: {
      headerIcon: 'home',
      hideSelectText: true,
      displayVehicleString: true,
    },
  },
  {
    path: 'error',
    name: 'trade-in-error-mobile',
    component: ErrorPage,
    meta: {
      headerIcon: 'home',
      errorPayload: {
        buttonText: 'returnHome',
      },
    },
  },
];
